module.exports = __webpack_public_path__ + "b5d2ac099016fe5a536e819c51e9c4b7.png";